import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { MuiContextProvider } from "context/MuiContext";
import { AuthContextProvider } from "context/AuthContext";
import { CacheContextProvider } from "context/CacheContext";
import App from "./App";

ReactDOM.render(
  <BrowserRouter>
    <CacheContextProvider>
      <AuthContextProvider>
        <MuiContextProvider>
          <App />
        </MuiContextProvider>
      </AuthContextProvider>
    </CacheContextProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
